define('entities/webshop/filters',[
  'app',
  'settings',
  'underscore'
], function (
  App,
  Settings,
  _
) {
  'use strict';

  // Webshop product filters (PHP webshop api/filters/**, through the backend webshop proxy).
  // Filters / values with an id >= 1 000 000 000 were created in the webshop; the others
  // come from the PIM sync, which rewrites their names and product assignments.

  var call = function (type, path, params, data) {
    var defer = $.Deferred();

    var options = {
      type: type,
      url: Settings.url('compuzz2', 'webshop/filters/' + path, params || {}),
      success: function (result) {
        defer.resolve(result);
      },
      error: function (jqXHR) {
        var message = '';
        if (jqXHR.responseJSON && jqXHR.responseJSON.message)
          message = jqXHR.responseJSON.message;
        defer.reject(message || _.i18n('webshop.errors.unknown', null, 'Unknown error'));
      }
    };

    if (data) {
      options.data = JSON.stringify(data);
      options.processData = false;
      options.contentType = 'application/json';
    }

    $.ajax(options);
    return defer.promise();
  };

  var API = {
    search: function (params) {
      return call('GET', 'search', params);
    },
    groups: function () {
      return call('GET', 'groups');
    },
    get: function (id) {
      return call('GET', 'get', {id: id});
    },
    add: function (data) {
      return call('POST', 'add', null, data);
    },
    update: function (data) {
      return call('PUT', 'update', null, data);
    },
    remove: function (id) {
      return call('DELETE', 'delete', {id: id});
    },
    addValue: function (data) {
      return call('POST', 'values/add', null, data);
    },
    updateValue: function (data) {
      return call('PUT', 'values/update', null, data);
    },
    removeValue: function (filterId, valueId) {
      return call('DELETE', 'values/delete', {filterId: filterId, valueId: valueId});
    },
    valueProducts: function (params) {
      return call('GET', 'values/products', params);
    },
    addValueProducts: function (filterId, valueId, productIds) {
      return call('POST', 'values/products/add', null, {filterId: filterId, valueId: valueId, productIds: productIds});
    },
    removeValueProducts: function (filterId, valueId, productIds) {
      return call('POST', 'values/products/delete', null, {filterId: filterId, valueId: valueId, productIds: productIds});
    },
    // Filters chosen for a category page, in display order ([] = every filter its products carry)
    categoryFilters: function (categoryId) {
      return call('GET', 'category', {categoryId: categoryId});
    },
    updateCategoryFilters: function (categoryId, filterIds) {
      return call('PUT', 'category/update', null, {categoryId: categoryId, filterIds: filterIds});
    },
    // Webshop filter id of a canonical attribute (PIM filters: 9 000 000 + attribute id)
    keyFilterId: function (keyId) {
      return 9000000 + keyId;
    },

    // Name in the dashboard language, then English, then any.
    name: function (names, lang) {
      names = names || {};
      lang = lang || Settings.get('lang');
      if (names[lang])
        return names[lang];
      if (names.en)
        return names.en;
      var first = _.find(_.values(names), function (n) { return !!n; });
      return first || '';
    },

    // 24-bit RGB int (-1 = no swatch) <-> '#rrggbb'
    colorToHex: function (color) {
      if (color === null || color === undefined || color < 0)
        return '';
      return '#' + ('000000' + parseInt(color, 10).toString(16)).slice(-6);
    }
  };

  App.reqres.setHandler('webshop.filters.api', function () {
    return API;
  });

  return API;
});

